
export const GET_BRANCH_REPORT_DATA = 'dashboardStats/getBranchReportData';
export const GET_BRANCH_REPORT_DATA_START = 'dashboardStats/getBranchReportDataStart';
export const GET_BRANCH_REPORT_DATA_COMPLETE =
  'dashboardStats/getBranchReportDataCompleted';
export const GET_BRANCH_REPORT_DATA_ERROR = 'dashboardStats/getBranchReportDataError';
export const GET_AGENCY_REPORT_GRAPH_DATA = 'dashboardStats/getAgencyReportGraphData';
export const GET_AGENCY_REPORT_GRAPH_DATA_START =
  'dashboardStats/getAgencyReportGraphDataStart';
export const GET_AGENCY_REPORT_GRAPH_DATA_COMPLETE =
  'dashboardStats/getAgencyReportGraphDataCompleted';
export const GET_AGENCY_REPORT_GRAPH_DATA_ERROR =
  'dashboardStats/getAgencyReportGraphDataError';
export const DOWNLOAD_AGENCY_REPORT = 'dashboardStats/downloadAgencyReport';
export const DOWNLOAD_AGENCY_REPORT_START = 'dashboardStats/downloadAgencyReportStart';
export const DOWNLOAD_AGENCY_REPORT_COMPLETE = 'dashboardStats/downloadAgencyReportCompleted';
export const DOWNLOAD_AGENCY_REPORT_ERROR = 'dashboardStats/downloadAgencyReportError';

export const GET_BRANCH_EMPLOYEES_DATA = 'dashboardStats/getBranchEmployeesData';
export const GET_BRANCH_EMPLOYEES_DATA_START =
  'dashboardStats/getBranchEmployeesDataStart';
export const GET_BRANCH_EMPLOYEES_DATA_COMPLETE =
  'dashboardStats/getBranchEmployeesDataCompleted';
export const GET_BRANCH_EMPLOYEES_DATA_ERROR =
  'dashboardStats/getBranchEmployeesDataError';

export const GET_EMPLOYEE_DETAILS = 'dashboardStats/getEmployeeDetails';
export const GET_EMPLOYEE_DETAILS_START = 'dashboardStats/getEmployeeDetailsStart';
export const GET_EMPLOYEE_DETAILS_COMPLETE = 'dashboardStats/getEmployeeDetailsCompleted';
export const GET_EMPLOYEE_DETAILS_ERROR = 'dashboardStats/getEmployeeDetailsError';

export const GET_CARE_COIN_TRACKER_DATA = 'dashboardStats/getCareCoinTrackerDeta';
export const GET_CARE_COIN_TRACKER_DATA_START =
  'dashboardStats/getCareCoinTrackerDetaStart';
export const GET_CARE_COIN_TRACKER_DATA_COMPLETE =
  'dashboardStats/getCareCoinTrackerDetaCompleted';
export const GET_CARE_COIN_TRACKER_DATA_ERROR =
  'dashboardStats/getCareCoinTrackerDetaError';

export const SEND_CARE_COINS = 'dashboardStats/sendCareCoins';
export const SEND_CARE_COINS_START = 'dashboardStats/sendCareCoinsStart';
export const SEND_CARE_COINS_COMPLETE = 'dashboardStats/sendCareCoinsCompleted';
export const SEND_CARE_COINS_ERROR = 'dashboardStats/sendCareCoinsError';

export const GET_SEARCH_EMPLOYEES_DATA = 'dashboardStats/getSearchEmployeesData';
export const GET_SEARCH_EMPLOYEES_DATA_START =
  'dashboardStats/getSearchEmployeesDataStart';
export const GET_SEARCH_EMPLOYEES_DATA_COMPLETE =
  'dashboardStats/getSearchEmployeesDataCompleted';
export const GET_SEARCH_EMPLOYEES_DATA_ERROR =
  'dashboardStats/getSearchEmployeesDataError';
export const CLEAR_SEARCH_DATA = 'dashboardStats/clearSearchData';
export const SET_EMPLOYEE_DATA = 'dashboardStats/setEmployeeData';
export const CLEAR_EMPLOYEE_DATA = 'dashboardStats/clearEmployeeData';

export const CLEAR_REPORTING_ERRORS = 'dashboardStats/clearReportingErrors';

export const EMPLOYEE_EARNING_FETCH = "employeeStats/startEmployeeEarningFetch";
export const EMPLOYEE_EARNING_FETCH_START = "employeeStats/startEmployeeEarningFetchStart";
export const EMPLOYEE_EARNING_FETCH_COMPLETE = "employeeStats/startEmployeeEarningFetchCompleted";
export const EMPLOYEE_EARNING_FETCH_ERROR = "employeeStats/startEmployeeEarningFetchError";

export const RETRY_REDEEM_REWARD = "employeeStats/retryRedeemReward";
export const RETRY_REDEEM_REWARD_START = "employeeStats/retryRedeemRewardStart";
export const RETRY_REDEEM_REWARD_COMPLETE = "employeeStats/retryRedeemRewardCompleted";
export const RETRY_REDEEM_REWARD_ERROR = "employeeStats/retryRedeemRewardError";

export const retryRedeemReward = (payload = {}) => ({
  type: RETRY_REDEEM_REWARD,
  payload,
});


export const setEmployeeData = (payload = {}) => ({
  type: SET_EMPLOYEE_DATA,
  payload,
});

export const clearEmployeeData = (payload = {}) => ({
  type: CLEAR_EMPLOYEE_DATA,
  payload,
});

export const clearSearchData = (payload = {}) => ({
  type: CLEAR_SEARCH_DATA,
  payload,
});

export const getSearchEmployeesData = (payload = {}) => ({
  type: GET_SEARCH_EMPLOYEES_DATA,
  payload,
});

export const clearReportingErrors = (payload = {}) => ({
  type: CLEAR_REPORTING_ERRORS,
  payload,
});

export const sendCareCoins = (payload = {}) => ({
  type: SEND_CARE_COINS,
  payload,
});

export const getBranchEmployeesData = (payload = {}) => ({
  type: GET_BRANCH_EMPLOYEES_DATA,
  payload,
});

export const getCareCoinTrackerDeta = (payload = {}) => ({
  type: GET_CARE_COIN_TRACKER_DATA,
  payload,
});

export const getEmployeeDetails = (payload = {}) => ({
  type: GET_EMPLOYEE_DETAILS,
  payload,
});

export const getBranchReportData = (payload = {}) => ({
  type: GET_BRANCH_REPORT_DATA,
  payload,
});

export const getAgencyReportGraphData = (payload = {}) => ({
  type: GET_AGENCY_REPORT_GRAPH_DATA,
  payload,
});

export const downloadAgencyReport = (payload = {}) => ({
  type: DOWNLOAD_AGENCY_REPORT,
  payload,
});

export const fetchEmployeeEarning = (payload = {}) => ({
  type: EMPLOYEE_EARNING_FETCH,
  payload,
});

export const fetchEmployeeEarningStart = (payload = {}) => ({
  type: EMPLOYEE_EARNING_FETCH_START,
  payload,
});

export const fetchEmployeeEarningComplete = (payload = {}) => ({
  type: EMPLOYEE_EARNING_FETCH_COMPLETE,
  payload,
});

export const fetchEmployeeEarningError = (payload = {}) => ({
  type: EMPLOYEE_EARNING_FETCH_ERROR,
  payload,
});